import { render, staticRenderFns } from "./ProductsFoundersProfile.vue?vue&type=template&id=63781376&scoped=true&"
import script from "./ProductsFoundersProfile.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersProfile.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersProfile.vue?vue&type=style&index=0&id=63781376&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63781376",
  null
  
)

export default component.exports